<script setup>
import { ref, onBeforeMount, onMounted } from "vue";
import clientConfig from "@/config/client";
import ProductPageTemplate from "./ProductPageTemplate.vue";
import AOS from "aos";

import { useHead } from "@vueuse/head";

const siteData = {
  title: `General Liability - PEN UNDERWRITING`,
  url: `https://www.penunderwriting.com.au/#/general-liability-overview`,
  description: `Our general liability underwriters anticipate the needs of brokers, creating innovative products and risk solutions across a broad range of liability classes.`,
};

onBeforeMount(() => {
  useHead({
    // Update Title and Meta
    title: siteData.title,
    meta: [
      { name: `description`, content: siteData.description },
      { name: `twitter:description`, content: siteData.description },
      { name: `twitter:title`, content: siteData.title },
      { name: `twitter:url`, content: siteData.url },
      { property: `og:site_name`, content: siteData.title },
      { property: `og:title`, content: siteData.title },
      { property: `og:url`, content: siteData.url },
      {
        property: `og:description`,
        content: siteData.description,
      },
      { itemprop: `name`, content: siteData.title },
      { itemprop: `url`, content: siteData.url },
      {
        itemprop: `description`,
        content: siteData.description,
      },
    ],
  });
});

onMounted(() => {
  AOS.init();
});

const copy = ref(clientConfig.content.pages.generalLiability);
</script>

<template>
  <ProductPageTemplate
    :id="copy.id"
    :pageTitle="copy.pageTitle"
    :subHeader="copy.subHeader"
    :mainbody="copy.mainbody"
    :pageName="copy.pageName"
    :teamDivision="copy.teamDivision"
    :contactEmail="copy.contactEmail"
    :brochureFile="copy.brochureFile"
    :brochureFile2="copy.brochureFile2"
    :brochureFile2Title="copy.brochureFile2Title"
    :brochureFile3="copy.brochureFile3"
    :brochureFile3Title="copy.brochureFile3Title"
  />
</template>
